import { Box, Container, Flex, Heading, Text, Stack, VStack } from '@chakra-ui/react';
import map from 'lodash/map';
import { useSearchParam } from 'react-use';

import { responsive } from '../../contexts/responsive'
import Button from '../../components/Button'
import useSlug from '../Layout/useSlug'
import Thanks from './Thanks';
import useHttpFunction from '../../hooks/useHttpFunction';

export { query } from '../portalQuery'

const CompletePage = (data) => {
  const slug = useSlug()
  const orderId = useSearchParam('id')
  const { data: orderData } = useHttpFunction(`/getOrderData?orderId=${orderId}`)

  const firstProject = map(data?.support.projects)[0]
  return (
    <Container py={responsive(4, 8)} as={Flex} flexDirection="column" justifyContent="center">
      <Stack
        bg="white"
        px="4"
        py="8"
        borderRadius="sm"
        boxShadow="sm"
        spacing="6"
        textAlign="center"
      >
        {/* <Heading as="h1" fontSize={responsive('1em', '1.5em')} fontWeight="500">支持成功</Heading> */}
        <VStack spacing="6" justifyContent="center" p="2">
          <Thanks
            {...firstProject}
            profileName={data.name}
            count={orderData?.data?.count}
          />
          {/* {orderData ? <Text>{orderData?.project} 系列</Text> : <Box><Spinner /></Box>} */}
          <Button colorScheme="primary" to={`/${slug}`} isFullWidth>返回</Button>
        </VStack>
      </Stack>
    </Container>
  );
}

export default CompletePage
